import { colors } from 'Shared/util/theme';
import { getPieChartData } from 'Shared/util/translations';


export const pieChartStatusInfo = [{
  status: 'notDue',
  sortOrder: 1,
  color: colors.chart.first,
}, {
  status: 'overdue',
  sortOrder: 2,
  color: colors.chart.second,
}, {
  status: 'reminder',
  sortOrder: 3,
  color: colors.chart.third,
}, {
  status: 'collection',
  sortOrder: 4,
  color: colors.chart.fourth,
}, {
  status: 'legalAction',
  sortOrder: 5,
  color: colors.chart.fifth,
}];

export const getPieChartDataCount = (invoices, t) => {
  const data = getPieChartData(pieChartStatusInfo, invoices, 'filterStatus', t);
  const chartData = data.chartData.reduce((acc, obj) => {
    acc[obj.event] = obj.count;
    return acc;
  }, {});
  return {
    data: chartData,
    colors: data.chartColors,
  };
};

export const getPieChartDataAmount = (invoices, t) => {
  const data = getPieChartData(pieChartStatusInfo, invoices, 'filterStatus', t);
  const chartData = data.chartData.reduce((acc, obj) => {
    acc[obj.event] = obj.amount;
    return acc;
  }, {});
  return {
    data: chartData,
    colors: data.chartColors,
  };
};
